/// <amd-module name="RMWidgets/ReleasePipelineWidget/ReleasePipelineStatusUtils" />

import { EnvironmentStatus } from "Release/Client/Contracts/Release";

import * as Resources from "RMWidgets/ReleasePipelineWidget/Resources";

/** Returns a css class name based on environment status */
export function getEnvironmentStatusClassName(environmentStatus: EnvironmentStatus): string {
    switch (environmentStatus) {
        case EnvironmentStatus.InProgress: return "environment-definition-overview-inprogress";
        case EnvironmentStatus.Succeeded: return "environment-definition-overview-successful";
        case EnvironmentStatus.Canceled: return "environment-definition-overview-stopped";
        case EnvironmentStatus.Rejected: return "environment-definition-overview-rejected";
        case EnvironmentStatus.Scheduled: return "environment-definition-overview-deferred";
        case EnvironmentStatus.PartiallySucceeded: return "environment-definition-overview-partiallysucceeded";
        case EnvironmentStatus.NotStarted:
        case EnvironmentStatus.Queued:
        case EnvironmentStatus.Undefined:
        default: return "environment-definition-overview-notstarted";
    }
}

/** Returns environment status as a user readable string */
export function getEnvironmentStatusText(environmentStatus: EnvironmentStatus): string {
    switch (environmentStatus) {
        case EnvironmentStatus.NotStarted: return Resources.EnvironmentStatus_NotStarted;
        case EnvironmentStatus.Scheduled: return Resources.EnvironmentStatus_Scheduled;
        case EnvironmentStatus.Queued: return Resources.EnvironmentStatus_Queued;
        case EnvironmentStatus.InProgress: return Resources.EnvironmentStatus_InProgress;
        case EnvironmentStatus.Succeeded: return Resources.EnvironmentStatus_Succeeded;
        case EnvironmentStatus.Canceled: return Resources.EnvironmentStatus_Canceled;
        case EnvironmentStatus.Rejected: return Resources.EnvironmentStatus_Rejected;
        case EnvironmentStatus.PartiallySucceeded: return Resources.EnvironmentStatus_PartiallySucceeded;
        default: return "";
    }
}

